export default __webpack_public_path__ + "static/TripReductionOrdinances-1bad3a4ca09ca678ce68d8928af0c23d.jpg";